import script from "./userMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./userMessages.vue?vue&type=script&setup=true&lang=js"

import "./userMessages.vue?vue&type=style&index=0&id=42bd606e&lang=css"

const __exports__ = script;

export default __exports__